<div
  class="w-full overflow-hidden rounded-2xl border border-[#e5e7eb] bg-white shadow-xl dark:border-surface-3 dark:bg-surface-1"
  (click)="$event.stopPropagation()"
>
  <div class="relative px-6 pb-2 pt-6">
    <button
      type="button"
      (click)="close()"
      class="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#f2f5f8] text-[#7d7d93] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
      aria-label="Close"
    >
      <app-icon-v2 name="x" size="16"></app-icon-v2>
    </button>

    <h3 class="pr-10 text-left text-[18px] font-bold leading-snug text-[#141437] dark:text-white">
      {{ title }}
    </h3>
  </div>

  <div class="flex flex-col items-center px-6 pb-2 pt-4 text-center">
    <div class="flex h-[88px] w-[88px] items-center justify-center" aria-hidden="true">
      <div class="error-badge-pop-in flex items-center justify-center">
        <div class="error-badge-gif">
          <app-icon-v2
            name="badge-x"
            size="88"
            [strokeWidth]="1.5"
            customClass="text-[#f05050]"
          ></app-icon-v2>
        </div>
      </div>
    </div>
    @if (amount != null) {
      <p class="mt-4 text-[32px] font-bold leading-tight text-[#141437] dark:text-white">
        {{ amount | currency }}
      </p>
    }
    <p
      class="text-[16px] font-medium text-[#141437] dark:text-white"
      [class.mt-4]="amount == null"
      [class.mt-2]="amount != null"
    >
      {{ statusMessage }}
    </p>
    @if (subtitle) {
      <p class="mt-3 max-h-40 w-full overflow-y-auto whitespace-pre-line text-left text-[13px] text-[#7d7d93] dark:text-ink-muted">
        {{ subtitle }}
      </p>
    }
  </div>

  <div class="px-6 pb-6 pt-4">
    <button
      type="button"
      class="inline-flex h-11 w-full items-center justify-center rounded-[10px] bg-[#ad46ff] text-[14px] font-semibold text-white transition hover:bg-[#962ef7]"
      (click)="close()"
    >
      {{ confirmLabel }}
    </button>
  </div>
</div>
